<!-- video 视频播放器 支持非流视频的播放 -->
<template>
      <div class="video-box" :style="{position:isFixed}">
        <div class="video-box-body" @mousemove="Enter" @mouseenter="Enter" @click="Enter">
          <div class="loader" v-show="isLoading">
            <svg
                  version="1.1"
                  class="loader-1"
                  x="0px"
                  y="0px"
                  width="100px"
                  height="100px"
                  viewBox="0 0 50 50"
                  style="enable-background:new 0 0 50 50;"
                  xml:space="preserve"
                >
              <path
                    fill="#000"
                    d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                    transform="rotate(110.097 25 25)"
                  >
                <animateTransform
                      attributeType="xml"
                      attributeName="transform"
                      type="rotate"
                      from="0 25 25"
                      to="360 25 25"
                      dur="0.6s"
                      repeatCount="indefinite"
                    />
              </path>
            </svg>
            <div class="load-msg">加载中,请稍后....</div>
          </div>
          <p class="emptyVideo" v-show="emptyVideoSrc">暂无视频源</p>
          <canvas v-show="isCanvas" class="video-body canvasRef" ref="canvasRef">您的浏览器不支持canvas</canvas>
          <video
                ref="mp4player"
                v-show="!isCanvas"
                class="video-body"
                :poster="require('@/assets/images/video_empty.jpg')"
                @ended="ended($event)"
                @error="error($event)"
                @loadstart="loadstart($event)"
                @canplay="canplay($event)"
                @seeking="seeking($event)"
                @seeked="seeked($event)"
                @timeupdate="timeupdate($event)"
              >您的浏览器不支持video</video>
          <!--控制条盒子-->
          <div class="video-control" v-if="isLoaded" v-show="isShowControl">
            <div class="pull-left fontzero control-leftview">

              <!--刷新键-->
              <!-- <div class="control-btn loadbtn"></div> -->
              <!--暂停/播放键-->
              <div class="control-btn playbtn" :class="{pausebtn:isPlay}" @click="playToggle"></div>
            </div>
            <div class="pull-left fontzero progress-box">
              <div class="progress-box-body">
                <!--播放时长-->
                <div class="current-time pull-left">{{currentDuration|initTimeLength}}</div>
                <div class="durationbar-box pull-left">
                  <!--总视频长度进度条-->
                  <div class="durationbar">
                    <!--缓冲进度条-->
                    <div class="bufferbar" :style="{width:getBuffPrecent+'%'}"></div>
                    <!--正在播放进度条-->
                    <div class="currentbar" :style="{width:(currentDuration/duration)*100+'%'}"></div>
                    <i class="keyPoint" v-for="(item,index) in keyIframeOffset" :key="index" :style="{left:(item/duration)*100+'%'}"></i>
                    <input
                          class="bar-input"
                          @mouseleave="removeDrawbar"
                          @mouseenter="setDrawbar"
                          @mouseup="sliderUp()"
                          @input="slider($event,'continue')"
                          @change="slider($event,'')"
                          type="range"
                          min="0"
                          max="100"
                          :value="getCurrentDurationPercent"
                        />
                  </div>
                </div>
                <!--总时长-->
                <div class="duration-time pull-left" v-if="videoCode == 'mp4'">{{duration|initTimeLength}}</div>
              </div>
            </div>
            <div class="pull-left fontzero control-rightview">
                <!--              <div class="video-cutScreen" v-if="showCutScreen">-->
                <!--                <span @click="cutVideoSrceen">截屏</span>-->
                <!--              </div>-->
                <!-- 清晰度切换 -->
<!--                <div class="defintion-wrap" v-show="isShowDefintion">-->
<!--                  <div-->
<!--                        class="leavel"-->
<!--                        v-for="(item,index) in videoUrl"-->
<!--                        :key="item.leave"-->
<!--                        :class="{isActive:defintion==item.leavel}"-->
<!--                        @click="chooseDefintion(item.leavel,index)"-->
<!--                      >{{item.leavel}}</div>-->
<!--                </div>-->
<!--                <div class="defintion" :title="defintion" @click="openDefintion">{{defintion}}</div>-->
              <!-- 倍数播放 -->
              <div class="speed-wrap" v-show="isShowSpeed">
                <div
                      class="leavel"
                      v-if="!linuxFlag ||  (item <= 2.0)"
                      v-for="item in Speed"
                      :key="item"
                      @click="chooseSpeed(item)"
                      :class="{isActive:speed==item}"
                    >X{{item.toFixed(1)}}</div>
              </div>
              <div class="speed" @click="openSpeed">X{{speed}}</div>
              <!--音量键-->
              <div class="control-btn mutedbtn" :class="{muted:isMuted}" @click="setMute()"></div>
              <div class="volumn-btn-wrap">
                <input
                      class="volume-input"
                      :style="{'background':'linear-gradient(to right, #a7bfe8, #6190e8 ' + volume + '%, #ebeff4)' }"
                      @input="setvolume($event)"
                      @change="setvolume($event,'end')"
                      type="range"
                      min="0"
                      max="100"
                      v-model="volume"
                    />
                <div class="volumn-btn" :style="{left:(volume)+'px'}"></div>
              </div>

              <!--全屏键-->
              <div class="control-btn fullscreenbar" @click="fullScreen"></div>
              <!-- <div class="control-btn mime" @click="switchMime()">{{mime}}</div> -->
            </div>
          </div>
          <div class="video-progress" v-if="ifisShowControl" v-show="!isShowControl">
            <div class="video-progress-current" :style="{width:(currentDuration/duration)*100+'%'}"></div>
          </div>
        </div>
      </div>
</template>
<script>
    export default {
    components: {},
    name: 'mp4',
    data() {
        return {
            mime: "mp4",
            currentDuration: "0",
            linuxFlag:false,
            leftArrow:"<<",
            rightArrow:">>",
            switchMoreInfo:false,
            currentDurationTemp: 0,
            duration: "1",
            getBuffPrecent: "",
            isPlay: false,
            refDom: null,
            mp4_player_instance: null,
            volume: 0,
            canvas: null,
            context: null,
            isCanvas: false,
            isShowControl: false,
            isLoading: false,
            isdrawbar_active: false,
            width: 0,
            height: 0,
            isFixed: "relative",
            timer: null,
            speed: 1,
            defintion: "",
            isShowSpeed: false,
            isShowDefintion: false,
            controlTimer: null,
            getCurrentDurationPercent: 0,
            isNotDrag: true, //标志是否拖动中，快进快退中避免更新进度条
            mp4VideoCode: "mp4",
            isLoaded: false,
            defintionTimer: null,
            speedTimer: null,
            isMuted: false,
        };
    },
    head() {
        return {};
    },
      computed: {
        emptyVideoSrc:function () {
          return this.videoUrl.length == 0;
        },
      },
    props: {
        // videoUrl: {
        //   type: String,
        //   default:
        //     "http://store.91yunshi.com/storage/videoAuth/gaugua/41175fe7fdc74354a8d99a3f7aa1457d.mp4?videoType=mp4&_t=1592535251776"
        // },
        id:{
          type: String,
          default:'1'
        },
        serverUrl:{
          type: String,
          default:''
        },
        showCutScreen:{
          type: Boolean,
          default:false
        },
        keyIframeOffset:{
            type: Array,
            default() {
                return [];
            },
        },
        Speed: {
            type: Array,
            default() {
                return [0.5, 1.0,2.0,3.0,4.0];
            },
        },
        ifisShowControl: {
            type: Boolean,
            default: false, //只支持mp4或MP4
        },
        isShowControls: {
          type: Boolean,
          default: true,
        },
        videoCode: {
            type: String,
            default: "mp4", //只支持mp4或MP4
            validator: function (value) {
                // 这个值必须匹配下列字符串中的一个
                return ["mp4", "mp4"].indexOf(value) !== -1;
            },
        },
        videoUrl: {
            type: Array,
            default() {
                return [
                    // {
                    //   playUrl:"http://store.91yunshi.com/storage/videoAuth/gaugua/41175fe7fdc74354a8d99a3f7aa1457d.mp4?videoType=mp4&_t=1592535251776",
                    //   leavel: "高清"
                    // },
                    // {
                    //   playUrl:"http://store.91yunshi.com/storage/videoAuth/gaugua/41175fe7fdc74354a8d99a3f7aa1457d.mp4?videoType=mp4&_t=1592535251776",
                    //   leavel: "超清"
                    // },
                    // {
                    //   playUrl:"http://store.91yunshi.com/storage/videoAuth/gaugua/41175fe7fdc74354a8d99a3f7aa1457d.mp4?videoType=mp4&_t=1592535251776",
                    //   leavel: "蓝光"
                    // }
                ];
            },
        },

    },
    watch: {
        videoUrl: {
            handler(newVal, old) {
                this.reloadUrl(true);
            },
            deep: true,
        },
    },
    filters: {
        initTimeLength(timeLength) {
            let result = parseInt(timeLength);
            let h =
                Math.floor(result / 3600) < 10
                    ? "0" + Math.floor(result / 3600)
                    : Math.floor(result / 3600);
            let m =
                Math.floor((result / 60) % 60) < 10
                    ? "0" + Math.floor((result / 60) % 60)
                    : Math.floor((result / 60) % 60);
            let s =
                Math.floor(result % 60) < 10
                    ? "0" + Math.floor(result % 60)
                    : Math.floor(result % 60);



            return `${h}:${m}:${s}`;
            // //根据秒数格式化时间
            // timeLength = parseInt(timeLength);
            // var second = timeLength % 60;
            // var minute = (timeLength - second) / 60;
            // return (
            //   (minute < 10 ? "0" + minute : minute) +
            //   ":" +
            //   (second < 10 ? "0" + second : second)
            // );
        },
        // speedFilter(val){
        //   console.log(val);
        //   let num = parseInt(val)
        //   return num.toFixed(1)
        // }
    },
    methods: {
        switchMime() {
            if (this.mime == "mp4") {
                this.mime = "mp4";
            } else {
                this.mime = "mp4";
            }
            this.$emit("mime", this.mime);
        },
        setDrawbar() {
            this.isdrawbar_active = true;
        },
        removeDrawbar() {
            this.isdrawbar_active = false;
        },
        Enter() {

          if(!this.isShowControls){
            return
          }

            clearTimeout(this.controlTimer);
            this.isShowControl = true;
            this.controlTimer = setTimeout(() => {
                this.isShowControl = false;
            }, 5000);
        },
        openDefintion() {
            //打开清晰度切换容器
            clearTimeout(this.defintionTimer);
            this.isShowDefintion = true;
            this.defintionTimer = setTimeout(() => {
                this.isShowDefintion = false;
            }, 3000);
        },
        chooseDefintion(defintion, index) {
            sessionStorage.setItem("mp4_defintion", index);
            sessionStorage.setItem("mp4_defintion_currenttime", this.refDom.currentTime);
            //选择清晰度
            this.defintion = defintion || '';
            this.isShowDefintion = false;
            this.$emit('switchCurrentVideo', this.videoUrl[defintion]);
            this.reloadUrl();
        },
        reloadUrl(sourceChange) {
            if(sourceChange){
              this.isPlay = false
            }
            this.mp4_destroy();
            this.initPlay();
        },
        openSpeed() {
            //打开播放速度容器
            clearTimeout(this.speedTimer);
            this.isShowSpeed = true;
            this.speedTimer = setTimeout(() => {
                this.isShowSpeed = false;
            }, 3000);
        },
        detectOS() {
          var sUserAgent = navigator.userAgent;
          var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
          var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
          if (isMac) return "Mac";
          var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
          if (isUnix) return "Unix";
          var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
          if (isLinux) return "Linux";
          if (isWin) {
            var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
            if (isWin2K) return "Win2000";
            var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
            if (isWinXP) return "WinXP";
            var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
            if (isWin2003) return "Win2003";
            var isWin2003Vista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
            if (isWin2003Vista) return "WinVista";
            var isWin2003Win7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
            if (isWin2003Win7) return "Win7";
          }
          return "None";
        },
        chooseSpeed(speed) {
            //选择播放速度
            this.refDom.playbackRate = this.linuxFlag?(speed*8.0).toFixed(1):speed;
            this.speed = speed;
            this.isShowSpeed = false;
        },
        setvolume(e, isend) {
            //设置音量
            let dom = e.target;
            if (isend == "end" && this.isMuted) {
                this.refDom.muted = false;
                this.isMuted = false;
            }
            this.refDom.volume = dom.value / 100;
            sessionStorage.setItem("fly_volume", dom.value / 100);
            this.volume = dom.value;
        },
        slider(e, type) {
            //进度滑动设置
            let dom = e.target;
            this.currentDuration = this.currentDurationTemp = (Number(dom.value) * this.duration) / 100;
            if (type == "continue") {
                this.refDom.pause();
            } else {
                this.refDom.currentTime = this.currentDuration;
                this.isPlay = false
            }
        },
        sliderUp() {
            this.refDom.currentTime = this.currentDurationTemp;
            // this.isNotDrag=true;
            //  console.log( this.isNotDrag);
            this.isPlay = false;
            this.refDom.play();
        },
        init(videoItem) {


            this.isLoaded = false; //播放器数据初始化能播放后再显示UI页面
            this.defintion = videoItem && videoItem.leavel || '';
            let url = "";
            this.refDom = this.$refs.mp4player;
            if (!videoItem) return;
            url = videoItem.playUrl;
            //mp4播放器初始化
            window.cancelAnimationFrame(this.timer);
            this.refDom.src = url;

        },
        mp4_destroy() {
            if (this.refDom) {
                this.refDom.pause();
                this.refDom.src = '';
                //mp4播放器初始化
                window.cancelAnimationFrame(this.timer);

            }
        },
        setMute() {
            if (!this.refDom.muted) {
                this.refDom.muted = true;
                this.isMuted = true;
            } else {
                this.refDom.muted = false;
                this.isMuted = false;
            }
        },
        canplay(e) {
            this.isLoaded = true;
            let currentTime = sessionStorage.getItem("mp4_defintion_currenttime"); //保存上次进度，切换清晰度的时候还原进度
            //资源可以播放
            let dom = e.target;
            if (!!currentTime) {
                dom.currentTime = currentTime;
                sessionStorage.removeItem("mp4_defintion_currenttime");
            }
            this.duration = dom.duration || 1;
            this.currentDuration = dom.currentTime || 0;
            dom.volume = sessionStorage.getItem("fly_volume") || 0.5;
            this.volume = dom.volume * 100;
            // this.speed = dom.playbackRate.toFixed(1);
            dom.playbackRate = this.linuxFlag?8.0:1.0;
            dom.play();
            this.isLoading = false;
            this.$emit("isplay", true);
        },
        getCanvasInit() {
            //canvas初始化
            this.canvas = this.$refs.canvasRef;
            this.context = this.canvas.getContext("2d");
            this.canvas.width = document.body.clientWidth;
            this.canvas.height = document.body.clientHeight;
            this.drawCanvas();
        },
        drawCanvas() {
            //绘制视频到canvas
            this.context.drawImage(
                this.refDom,
                0,
                0,
                this.canvas.width,
                this.canvas.height
            ); //绘制视频
            this.timer = window.requestAnimationFrame(this.drawCanvas);
        },
        playToggle() {
            //播放暂停
            if (this.refDom.paused) {
                this.refDom.play();
                this.isPlay = false;
            } else {
                this.refDom.pause();
                this.isPlay = true;
            }
        },
        play() { // 播放
          if( this.refDom ){
            this.refDom.play();
            this.isPlay = false;
          }
        },
        pause() { // 暂停
          if(this.refDom){
            this.refDom.pause();
            this.isPlay = true;
          }
        },
        fullScreen() {

          var ele = this.$refs.mp4player;
          if (ele.requestFullscreen) {
            ele.requestFullscreen();
          } else if (ele.mozRequestFullScreen) {
            ele.mozRequestFullScreen();
          } else if (ele.webkitRequestFullScreen) {
            ele.webkitRequestFullScreen();
          }


            // if (this.isFixed == "fixed") {
            //     //如果全屏退出全屏
            //     this.isFixed = "relative";
            //     // this.isCanvas = false;
            //     // window.cancelAnimationFrame(this.timer);
            // } else {
            //     this.isFixed = "fixed";
            //     // this.isCanvas = true;
            //     // this.getCanvasInit();
            // }
        },
        ended(e) {
            this.$emit("mp4Ended", true);
        },
        seeking(e) {
            // console.log(e);
            this.isLoading = true;
        },
        seeked(e) {
            this.isLoading = false;



            // console.log(e);
        },
        error(e) {
                    //如果是格式错误，尝试切换格式播放
                  let err = e.target.error;
                  console.error(err);

                  if (err.code == 4) {
                    //error.code; //1.用户终止 2.网络错误 3.解码错误 4.playUrl无效
                    if (this.mp4VideoCode == "mp4") {
                    this.mp4VideoCode = "mp4";
                    console.warn("尝试切换mp4格式播放");
                } else {
                    console.warn("尝试切换mp4格式播放");
                    this.mp4VideoCode = "mp4";
                }

                this.$message({
                  type: 'error',
                  message: '视频地址无效或视频合并中，请刷新后播放。'
                })

                // this.reloadUrl();
            }
            this.isLoading = false;
        },
        loadstart() {
            this.isLoading = true;
        },
        timeupdate(e) {
            //播放进度更新回调
            let dom = e.target;
            // 视频时长
            this.duration = dom.duration || 1;
            // currentTime 当前播放时长
            this.currentDuration = dom.currentTime;
            //当前缓冲进度时长结束位置
            let buffLength = dom.buffered.length;
            if (buffLength != 0) {
                var currentBuffer = dom.buffered.end(buffLength - 1);
                var percentage = (100 * currentBuffer) / this.duration;
                this.getBuffPrecent = percentage;
            }
            if (this.isNotDrag) {
                this.getCurrentDurationPercent =
                    (this.currentDuration / this.duration) * 100;
            }
        },
        setCurrentTime(timeDeviationSec){

            if(this.keyIframeOffset.indexOf(timeDeviationSec) > -1){
                this.refDom.currentTime = timeDeviationSec;
                this.isPlay = false

            }else{

                this.$message({
                    type: 'error',
                    message: '无效关键帧，无法定位。'
                })
            }


        },
      cutVideoSrceen(){

        var fileType = "png";  // 如果文件名中没有带后缀，默认使用png
        var video = this.$refs.mp4player;  // 找到需要截图的video标签
        var canvas = window.canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);  // 图片大小和视频分辨率一致
        var strDataURL = canvas.toDataURL("image/" + fileType);   // canvas中video中取一帧图片并转成dataURL
        var arr = strDataURL.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        var blob = new Blob([u8arr], {
          type: mime
        });

        const formData = new FormData();
        formData.append('file', blob);

        if(blob){

          this.$http.post('/person/sysWhiteList/uploadFile',formData ).then(res => {


            if(res.data.code == "1"){
              var filePath = res.data.data;
              this.$emit('cutAndUploadSuccess', filePath);

            }else{
              this.$message({message: "上传失败", type: "error"});
            }

          }).catch(e => {

          })

        }


        // var url = window.URL.createObjectURL(blob);
        // var a = document.createElement('a');
        // a.style.display = 'none';
        // a.href = url;
        // a.download = 'screen.png';
        // document.body.appendChild(a);
        // a.click();
        // setTimeout(function () {
        //   document.body.removeChild(a);
        //   window.URL.revokeObjectURL(url);
        // }, 1000);

      },
      initPlay() {

          let defintion = sessionStorage.getItem("mp4_defintion");
          if (!!defintion) {
              //如果本地保存了清晰度自动选择之前清晰度,否则加载第一个
            this.init(this.videoUrl[defintion]);
          }else if(this.videoUrl[0] && this.videoUrl[0].playUrl ){
            this.init(this.videoUrl[0]);
          }else{
            this.mp4_destroy();
          }
      },


    },
    mounted() {
        // console.log(this.videoUrl)
        this.mp4VideoCode = this.videoCode;
        this.initPlay();
        this.linuxFlag = this.detectOS() == 'Linux'


    },
  };
</script>
<style scoped>
/*video样式*/
.video-box {
  top: 0;
  left: 0;
  overflow: hidden;
  background: #000;
  width: 100%;
  height: 100%;
  z-index: 900;
}
.video-box-body {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.video-body {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

}
.canvasRef {
  width: 80%;
  left: 10%;
}
/*控制条样式*/
.video-control {
  display: flex;
  position: absolute;
  width: 100%;
  height: 60px;
  padding: 5px;
  line-height: 50px;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0 1px 15px 15px rgba(0, 0, 0, 0.5);
  transition-duration: 300ms;
  z-index: 900;
  left: 0;
  bottom: 0;
}
.control-leftview {
  display: flex;
  position: relative;
  z-index: 5;
  width: 120px;
}
.control-btn {
  display: inline-block;
  width: 25px;
  height: 25px;
  background: rgba(256, 256, 256, 0.5);
  cursor: pointer;
}
.control-leftview .control-btn {
  margin-right: 10px;
}
.progress-box {
  width: 85%;
  height: 50px;
  padding-right: 20px;
}
.progress-box-body {
  display: flex;



  width: 100%;
  height: 100%;
}
.current-time,
.duration-time {
  width: 60px;
  text-align: center;
  color: #fff;
}
.current-time {
  margin-right: -60px;
  position: relative;
  z-index: 5;
}
.duration-time {
  margin-left: -60px;
  position: relative;
  z-index: 5;
}
.durationbar-box {
  position: relative;
  width: 100%;
  padding: 0 70px;
}
.durationbar {
  width: 100%;
  height: 6px;
  margin-top: 23px;
  background: #fff;
  border-radius: 50px;
  position: relative;
}
.keyPoint{
    width:10px;
    height:10px;
    border-radius: 5px;
    display: inline-block;
    z-index: 11;
    position: absolute;
    top: -2px;
    background-color:#eef1f8;
}

.bufferbar,
.currentbar {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 0;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 50px;
  z-index: 5;
  cursor: pointer;
}
.currentbar {
  background: linear-gradient(to right, #a7bfe8, #6190e8);
  z-index: 10;
}

.control-rightview {
  cursor: pointer;
  position: relative;
  width: 470px;
  vertical-align: top;
  z-index: 5;
}
.speed {
  display: inline-block;
  width: 40px;
  color: #fff;
  hieght:50px;
  font-size: 16px;
}
.defintion {
  display: inline-block;
  color: #fff;
  line-height: 50px;
  overflow: hidden;
  font-size: 14px;
  width: 40px;
  height: 30px;
}

.video-cutScreen{
  display: inline-block;
  color: #fff;
  font-size: 14px;
  width: 40px;
}

.isActive {
  color: coral;
}
.leavel {
  cursor: pointer;
}
.speed-wrap {
  position: absolute;
  bottom: 50px;
  left: 44px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 0 10px;
  border-radius: 6px;
  line-height: 30px;
  font-size: 16px;
}



.defintion-wrap {
  position: absolute;
  bottom: 50px;
  left: -10px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 0 10px;
  border-radius: 6px;
  line-height: 30px;
  font-size: 16px;
}
.control-rightview .control-btn {
  margin-left: 10px;
  vertical-align: middle;
}
.control-leftview .control-btn:last-child,
.control-rightview .control-btn:first-child {
  margin: 0;
}
.control-btn.loadbtn {
  /* background: url(../img/load.png) no-repeat center; */
  background-size: 100%;
}
.control-btn.playbtn {
  width: 50px;
  height: 50px;
  background: url("../../assets/img/camera/pause.png") no-repeat center;

  background-size: 100%;
}
.control-btn.playbtn.pausebtn {

  background: url("../../assets/img/camera/play.png") no-repeat center;
  background-size: 100%;
}
.control-btn.mutedbtn {
  background: url("data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmZmZmIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0zIDl2Nmg0bDUgNVY0TDcgOUgzem0xMy41IDNjMC0xLjc3LTEuMDItMy4yOS0yLjUtNC4wM3Y4LjA1YzEuNDgtLjczIDIuNS0yLjI1IDIuNS00LjAyek0xNCAzLjIzdjIuMDZjMi44OS44NiA1IDMuNTQgNSA2Ljcxcy0yLjExIDUuODUtNSA2LjcxdjIuMDZjNC4wMS0uOTEgNy00LjQ5IDctOC43N3MtMi45OS03Ljg2LTctOC43N3oiLz4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KPC9zdmc+Cg==")
    no-repeat center;
  background-size: 100%;
}
.control-btn.muted {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAACZklEQVR4Xu2avy4FQRTGvxM9SomSChGVRCehUQkJiV6vEjrUXkNF4s8TeAQVFRoPIPECnxyZm6yxu7PuWHd2z2xzczN39u73m++c+bNHYPwS4/qRAWQHGCeQQ8C4AUaTBEluAFgGcCEiL6MchH8NAZIzAI4B7DvRNyKybQIAyQMnfqooWET+dRB82K3/Ocl1AEcA9PPH1VsAJHWk1e468pVXLwGQ1BhX8RrztVevAJBccXbfDAkftPcCAMlxJ1xjfaypeP1d5wGQ3HN2X/yN8KQcQHIHwAmA+WFExPQZuQNIqvDTGBExfVMA8ABgKUZETN8UADBGQGzfDGDUS2GS2QGxNo7pXxcChdlpGsA9gMPQ9tntOM8BrAF4BXArImdVzyipOqBidnoEsCsiT2WCSM4BuCyZzrXPVelmLGEAVbNTKYQa8ar7UUQWugbgHcBkhXW/QQiI11t8iMhE1wBcA9iqyS9fEFx7me2LXStPnlLOAbqVvgssz5+dytkAqM2q5JksABXUwNqhCag2aX7tRlNNggNlERCC4jsBYEgnNBLfGQAFCJoT6uJdf6p5QWO+dK3gx0zyIeCFgk0AQ+SB/oTAEOIHpmkEIekQiBDfGEKyANyuzu5CiKT5pbD5zZD57XDZcb2dAxG3+hu8sLF3JBba5v1Ve7LT4F8JDN0nAyBp/tWY7ZejXra193o8lCRC7b0okAiJDLWbLpEpwjFbJOU7xGyZnOcGu4WSHgibpbIlYWGzWNpzg91yeQ/Eqvv+Fqr4CE3Bse2tl8vHPmDb/TOAtgmnfv/sgNRHqO3nyw5om3Dq9/8EUtNyUHSPJr8AAAAASUVORK5CYII=")
    no-repeat center;
  background-size: 100%;
}
.control-btn.fullscreenbar {
  background: url("../../assets/img/camera/fullscreen.png") no-repeat center;
  background-size: 100%;
}
.control-btn.mime {
  line-height: 25px;
  background: none;
  color: #fff;
}
.bar-input {
  position: absolute;
  height: 100%;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  opacity: 0;
  z-index: 900;
  cursor: pointer;
}
.volumn-btn-wrap {
  position: relative;
  display: inline-block;
  width: 120px;
}
/* .volumn-btn-slider{

} */
.volumn-btn {
  position: absolute;
  left: 0;
  top: 20px;
  height: 20px;
  width: 20px;
  transform: translateY(0px);
  background: #fff;
  border-radius: 15px;
  border: 5px solid #6190e8;
  z-index: -1;
}
.volume-input {
  height: 100%;
  width: 100%;
  /* opacity: 0; */
  z-index: 900;
  cursor: pointer;
}
.loader {
  width: 140px;
  height: 140px;
  /* border: 1px solid red; */
  text-align: center;
  position: absolute;
  top: calc(50% - 40px);
  left: calc(50% - 70px);
  padding-top: 15px;
  z-index: 9009;
  border-radius: 5px;
}



.loader-1 {
  width: 60px;
  height: 60px;
}
svg path,
svg rect {
  fill: #17a085;
}
.load-msg {
  height: 50px;
  line-height: 50px;
  color: #fff;
  font-size: 13px;
   margin-top: 20px;
}
.volume-input {
  /*-webkit-box-shadow: 0 1px 0 0px #424242, 0 1px 0 #060607 inset, 0px 2px 10px 0px black inset, 1px 0px 2px rgba(0, 0, 0, 0.4) inset, 0 0px 1px rgba(0, 0, 0, 0.6) inset;*/
  -webkit-appearance: none; /*去除默认样式*/
  margin-top: 24px;
  background-color: #ebeff4;
  /*border-radius: 15px;*/
  -webkit-appearance: none;
  height: 4px;
  padding: 0;
  border: none;
  outline: none;
  /*input的长度为80%，margin-left的长度为10%*/
}
.volume-input::-webkit-slider-thumb {
  -webkit-appearance: none; /*去除默认样式*/
  cursor: pointer;
  top: 0;
  height: 20px;
  width: 20px;
  transform: translateY(0px);
  background: #fff;
  border-radius: 15px;
  border: 5px solid #6190e8;
  /*-webkit-box-shadow: 0 -1px 1px #fc7701 inset;*/
}
video:-webkit-full-screen {
  z-index: 9 !important;
  width: 100% !important;
  height: 100% !important;
}
video::-webkit-media-controls {
  display: none !important;
}
.video-progress {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  height: 4px;
  z-index: 900900;
}
.video-progress-current {
  position: absolute;
  width: 0%;
  left: 0;
  bottom: 0;
  height: 4px;
  border-radius: 2px;
  background: tomato;
}


.video-src-switch{
  position: absolute;
  background: #ffffff;
  top: 20px;
  right: 20px;

}

.link.active{
  background-color: #1965FF;
  color: white!important;
}
.link:hover {
  cursor: pointer;
  background-color: #1965FF;
  color: white!important;
}

.emptyVideo{
  position: absolute;
  top: 66%;
  color: #909399;
  z-index: 100;
  left: calc(50% - 40px);
}



</style>